import { render, staticRenderFns } from "./SpaceText.vue?vue&type=template&id=4906cd0e"
import script from "./SpaceText.vue?vue&type=script&lang=js"
export * from "./SpaceText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports